import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { usePokerSundayMillionWidget } from '../../../model';
import Skeleton from '../../Skeleton/Skeleton';

import { TXTCLI_THE_WORLDXS_MOST_ICONIC_WEEKLY_ELL } from './EventTitle.messages.json';
import styles from './EventTitle.scss';

const EventTitle: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const isLoading = useSelector(widgetSelect.isLoading);

  return (
    <div className={styles.root}>
      {isLoading ? (
        <Skeleton sx={{ display: 'inline-block', width: 500, height: 30 }} />
      ) : (
        <Translation {...TXTCLI_THE_WORLDXS_MOST_ICONIC_WEEKLY_ELL} />
      )}
    </div>
  );
};

export default EventTitle;
